import React from 'react';
import { NestedTable } from '../../../../TypeDetails/NestedTable';
import { SectionContainer } from '../../../../SectionContainer';
import style from './mainEntityDetails.scss';
import MemberDocs, { MemberTypes } from '../../../../TypeDetails/MemberDocs';
import { FeedbackContainer } from '../../../../Feedback';
import PropTypes from 'prop-types';

export const MainEntityDetails = ({ message, prefix, id, node }) => (
  <div className={style.mainEntityDetails}>
    <MemberDocs
      memberType={MemberTypes.MAIN}
      memberObject={message}
      node={node}
      prefix={prefix}
    />
    <SectionContainer title="Attributes">
      <NestedTable
        tableDepth={0}
        params={message.members}
        isMainEntity={true}
      />
    </SectionContainer>
    <FeedbackContainer memberId={id} />
  </div>
);

MainEntityDetails.propTypes = {
  message: PropTypes.any,
  hashPrefix: PropTypes.string,
  id: PropTypes.string,
  prefix: PropTypes.string,
};
